module.exports = __webpack_public_path__ + "static/media/locked.0c98160d.svg";